export default __webpack_public_path__ + "static/media/hito-2.36b814b6.png";